import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c(VDataTable, {
                staticClass: "table-inca",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.items,
                  dense: "",
                  "hide-default-footer":
                    Object.keys(_vm.items).length <= 10 ? true : false,
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.powerbi_dataset",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c("dataset-log-detail", {
                          attrs: { items: item.powerbi_dataset },
                        }),
                      ]
                    },
                  },
                  {
                    key: "item.powerbi_report",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c("dataset-log-detail", {
                          attrs: { items: item.powerbi_report },
                        }),
                      ]
                    },
                  },
                  {
                    key: "item.datastudio_report",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c("report-gds-log-detail", {
                          attrs: { items: item.datastudio_report },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }